export class DeploymentStore {
  constructor(
    private _updateAvailable = false,
    private _remainingSeconds: number | null = null,
  ) {}

  /** "remainingSeconds" null: the update is offered, but the tab does not reload itself. */
  public announceUpdate(remainingSeconds: number | null) {
    this._updateAvailable = true;
    this._remainingSeconds = remainingSeconds;
  }

  /** The tab turned out to run the deployed build after all. */
  public withdrawUpdate() {
    this._updateAvailable = false;
    this._remainingSeconds = null;
  }

  public countDown() {
    if (this._remainingSeconds !== null && this._remainingSeconds > 0) {
      this._remainingSeconds--;
    }
  }

  /** Only true if the update could not be applied unnoticed and the user has to be asked. */
  public get isUpdateAvailable(): boolean {
    return this._updateAvailable;
  }

  public get remainingSeconds(): number | null {
    return this._remainingSeconds;
  }
}

export const deploymentStore = new DeploymentStore();
